export default __webpack_public_path__ + "alberta-direct-order.e6a79b85231f2cb0f9ea.svg";